<template>
    <v-form ref="form" class="form-container" lazy-validation>
        <v-textarea
            v-if="getCurrentSMSCampaign"
            v-model="textTemplate"
            class="form-field"
            :label="`SMS text template, You can use up to ${getCurrentSMSCampaign.params} placeholder(s)`"
            hint="Click on the buttons below to insert a placeholder to your SMS text, each placeholder represents column 2 and above. Column 1 is reserved for your recipient(s) list."
            :rules="[
                v => !!v || 'Field Required'
            ]"
            required
        />
        <div v-if="getCurrentSMSCampaign" class="params-container">
            <div v-for="param in getCurrentSMSCampaign.params" :key="param">
                <v-btn color="cyan" dark @click="addParamInText(param)">
                    Param {{ param }}
                </v-btn>
            </div>
        </div>
        <create-form-actions
            has-previous-step-btn
            @reset="reset"
            @cancel="cancel"
            @next-step="emitNextStep"
            @previous-step="emitPrevStep"
        />
    </v-form>
</template>

<script>
    import CreateFormActions from '@/components/CreateFormActions.vue'
    import EventBus from '@/event-bus'
    export default {
        components: { CreateFormActions },
        data() {
            return {
                textTemplate: '',
                submitLoading: false
            }
        },
        computed: {
            getCurrentSMSCampaign() {
                return this.$store.getters.getCurrentRecurringSMSCampaign
            }
        },
        created() {
            EventBus.$on('reset-new-campaign-form', () => {
                this.textTemplate = ''
                this.submitLoading = false
            })
        },
        methods: {
            addParamInText(param) {
                this.textTemplate += ` {PARAM${param}} `
            },
            emitNextStep() {
                if (!this.$refs.form.validate()) { return }
                const campaign = {
                    ...this.getCurrentSMSCampaign,
                    textTemplate: this.textTemplate
                }
                this.$store.dispatch('setCurrentRecurringSMSCampaign', campaign)
                this.submitLoading = true
                this.$emit('next-step')
            },
            emitPrevStep() {
                this.$emit('prev-step')
            },
            reset() {
                this.$emit('reset')
            },
            cancel() {
                this.$emit('cancel')
            }
        }
    }
</script>

<style scoped>
.params-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    column-gap: 15px;
    margin-bottom: 20px;
}

.form-container {
    margin-bottom: 10px;
}

.form-field {
    width: 100%;
    margin-bottom: 30px;
    padding-left: 15px !important;
    padding-right: 15px !important;
}
</style>
